





























































































































import { Component, Vue } from "vue-property-decorator";
import AsesmenKeperawatanGadarStore from "@/store/modules/AsesmenKeperawatanGadarStore";
import SurveyPrimerIgdStore from "@/store/modules/SurveyPrimerIgdStore";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";

@Component
export default class PreviewAsesmenPerawatGadar extends Vue {
  get register() {
    return RegisterKunjungan.register["no"];
  }

  get storeAsesmenPerawat() {
    return AsesmenKeperawatanGadarStore;
  }

  get riwayatObstetri() {
    return AsesmenKeperawatanGadarStore.asesmen?.id
      ? AsesmenKeperawatanGadarStore.asesmen.content.riwayatObstetri
      : {
          riwayat: "-",
          g: "-",
          p: "-",
          a: "-",
          hpht: "-",
          hpl: "-",
          palpasi: "-",
          tfu: "-",
          tbj: "-",
          his: "-",
          djj: "-",
          panggul: "-",
          vt: "-",
          lla: "-",
          tb: "-",
          bb: "-",
          kb: "-",
          kbDescription: "-"
        };
  }

  get riwayatKb() {
    return AsesmenKeperawatanGadarStore.asesmen?.content?.riwayatObstetri.kb
      ?.name;
  }

  get riwayatKesehatan() {
    return AsesmenKeperawatanGadarStore.asesmen?.id
      ? AsesmenKeperawatanGadarStore.asesmen.content.riwayatKesehatan
      : {
          alergi: "-",
          obat: "-",
          penyakitLalu: "-",
          makanTerakhir: "-",
          lain: "-"
        };
  }

  get tensiText() {
    if (this.tandaVital?.tensi) {
      const { sistole, diastole } = this.tandaVital.tensi;

      return sistole + (sistole && diastole ? "/" : "") + diastole;
    } else {
      return "-";
    }
  }

  get tandaVital() {
    return this.storeAsesmenPerawat.asesmen?.id
      ? this.storeAsesmenPerawat.asesmen.content.tanda_vital
      : {
          tensi: null,
          nadi: "-",
          nafas: "-",
          suhu: "-",
          saturasi: "-"
        };
  }

  async refreshIsianKeperawatan() {
    await SurveyPrimerIgdStore.getByRegister(this.register);
    await AsesmenKeperawatanGadarStore.getByRegister(this.register);
  }
}
